import React from 'react'
import qs from 'qs'
import irelandApi from '../irelandApi'
import {actions} from 'react-redux-form'
import {toast} from 'react-toastify'
import store, {history} from '../store'
import ToastMessage from '../components/common/toast-message'

const assembleUserDetails = (payLoad) => {
  const mPayLoad = {...payLoad};
  mPayLoad.staff_permission_ids = [];
  Object.keys(payLoad.staff_permission_ids).forEach(function (key) {
    if (payLoad.staff_permission_ids[key].checked === 'true') {
      mPayLoad.staff_permission_ids.push(key);
    }
  });
  return mPayLoad;
};


export const getUsers = (query, userGroup, status, page) => (dispatch) => {
  dispatch({type: "GET_USER_LIST_PENDING"});
  let q = {text: query, user_group_id: userGroup, status: status};
  return irelandApi.get(`/api/admin/manage_users?${qs.stringify({q: q}, {encodeValuesOnly: true})}&page=${page}`)
    .then((response) => {
      dispatch({type: "GET_USER_LIST_FULFILLED", payLoad: response.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_USER_LIST_REJECTED', payLoad: error.data})
    })
};

export const getUserDetails = (id) => (dispatch) => {
  dispatch({type: "GET_USER_PENDING"});
  const link = `/api/admin/manage_owners/${id}`;
  return irelandApi.get(link)
    .then((response) => {
      const attributes = response.data.data.attributes;
      const permissions = response.data.data.relationships['staff-permissions'];
      const permission_ids = {};
      if (permissions) {
        permissions.data.forEach(item => {
          permission_ids[item.id] = {
            name: item.name,
            checked: '' + item.checked
          }
        });
      }

      const user = {
        title: attributes.title,
        first_name: attributes['first-name'],
        last_name: attributes['last-name'],
        date_of_birth: attributes['date-of-birth'],
        personal_address_1: attributes['personal-address-1'] || '',
        personal_address_2: attributes['personal-address-2'] || '',
        personal_address_3: attributes['personal-address-3'] || '',
        personal_address_4: attributes['personal-address-4'] || '',
        personal_eircode: attributes['personal-eircode'] || '',
        comms_email: attributes['comms-email'] || false,
        comms_mobile: attributes['comms-mobile'] || false,
        email: attributes['email'] || '',
        mobile: attributes['mobile'] || '',
        status: attributes.status,
        account_locked: '' + attributes['account-locked'],
        staff_permission_ids: permission_ids
      };

      dispatch(actions.load('deep.admin_user.details', user));
      dispatch({type: "GET_USER_FULFILLED", payLoad: response.data, saveLink: link});
    })
    .catch((error) => {
      dispatch({type: 'GET_USER_REJECTED', payLoad: error.data})
    })
};

export const getUserEdit = (id) => (dispatch) => {
  dispatch({type: "GET_USER_PENDING"});
  const link = `/api/admin/manage_admins/${id}`;
  return irelandApi.get(link)
    .then((response) => {
      const attributes = response.data.data.attributes;
      const user = {
        title: attributes.title,
        first_name: attributes['first-name'],
        last_name: attributes['last-name'],
        comms_email: attributes['comms-email'] || 'true',
        email: attributes['email'] || '',
        status: '' + attributes.status,
        account_locked: '' + attributes['account-locked'],
        user_group_id: '' + attributes['user-group-id'],
      };

      dispatch(actions.load('deep.admin_user.edit', user));
      dispatch({type: "GET_USER_FULFILLED", payLoad: response.data, saveLink: link});
    })
    .catch((error) => {
      dispatch({type: 'GET_USER_REJECTED', payLoad: error.data})
    })
};

export const getUserBaseData = () => (dispatch) => {
  dispatch({type: "INITIALIZE_ADD_USER_PENDING"});
  return irelandApi.get('/api/admin/manage_admins/new')
    .then((response) => {
      const meta = response.data.meta;
      dispatch({type: "INITIALIZE_ADD_USER_FULFILLED", payLoad: meta});
    })
    .catch((error) => {
      dispatch({type: 'INITIALIZE_ADD_USER_REJECTED', payLoad: error.data})
    })
};

export const saveUser = (payLoad) => {
  return irelandApi.post('/api/admin/manage_owners/', {'user': assembleUserDetails(payLoad)})
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="User has been saved successfully"/>);
      store.dispatch({type: 'USER_SAVE_SUCCESSFUL'});
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save user"/>);
      store.dispatch(actions.resetValidity('deep.admin_user.details'));
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data)
    })
};

export const saveAdmin = (payLoad) => {
  return irelandApi.post('/api/admin/manage_admins/', {'user': payLoad})
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="User has been saved successfully"/>);
      store.dispatch({type: 'ADMIN_SAVE_SUCCESSFUL', payLoad: response.data});
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save user"/>);
      store.dispatch(actions.resetValidity('deep.admin_user.edit'));
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data)
    })
};

export const updateUser = (link, payLoad) => {
  return irelandApi.patch(link, {'user': assembleUserDetails(payLoad)})
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="User has been saved successfully"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save user"/>);
      store.dispatch(actions.resetValidity('deep.admin_user.details'));
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data)
    })
};

export const updateAdmin = (id, payLoad) => {
  return irelandApi.patch(`/api/admin/manage_admins/${id}`, {'user': payLoad})
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="User has been saved successfully"/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save user"/>);
      store.dispatch(actions.resetValidity('deep.admin_user.edit'));
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data)
    })
};

export const sendWelcomeEmail = (id) => (dispatch) => {
  return irelandApi.post(`/api/admin/manage_admins/${id}/generate_welcome_email`)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Welcome email sent successfully"/>);
      dispatch({type: 'WELCOME_EMAIL_SENT'});
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Unable to send welcome email"/>);
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data)
    })
};

export const updatePermissions = (id, payLoad) => {
  return irelandApi.patch(`/api/admin/manage_owners/${id}/permissions`, {'user': assembleUserDetails({staff_permission_ids: payLoad})})
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="User permissions has been saved successfully"/>);
      store.dispatch(actions.reset('deep.admin_user.edit'));
      store.dispatch(actions.reset('deep.admin_user.details'));
      history.push('/admin/users');
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occurred during save user permissions"/>);
      store.dispatch(actions.resetValidity('deep.admin_user.edit'));
      store.dispatch(actions.resetValidity('deep.admin_user.details'));
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data)
    })
};

export const deleteUser = (id) => (dispatch) => {
  dispatch({type: "DELETE_USER_PENDING"});
  return irelandApi.delete(`/api/admin/manage_owners/${id}`)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="User has been deleted successfully"/>);
      dispatch({type: "DELETE_USER_FULFILLED", payLoad: response.data, id: id});
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during delete user"/>);
      dispatch({type: 'DELETE_USER_REJECTED', payLoad: error.data});
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    })
};

export const deleteAdmin = (id) => (dispatch) => {
  dispatch({type: "DELETE_ADMIN_PENDING"});
  return irelandApi.delete(`/api/admin/manage_admins/${id}`)
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="User has been deleted successfully"/>);
      dispatch({type: "DELETE_ADMIN_FULFILLED", payLoad: response.data, id: id});
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="An error occured during delete user"/>);
      dispatch({type: 'DELETE_ADMIN_REJECTED', payLoad: error.data});
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data);
    })
};

export const doPseudoLogin = (id) => (dispatch) => {
  return irelandApi.post('/api/admin/users/pseudo_sign_in', {pseudo_user_id: id})
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Pseudo login active, redirecting..."/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Unable to go to pseudo mode"/>);
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data)
    })
};

export const doPseudoLogout = (id) => (dispatch) => {
  return irelandApi.delete('/api/admin/users/pseudo_sign_out', {pseudo_user_id: id})
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="Pseudo logout succeeded"/>);
      dispatch({type: 'DELETE_LOGOUT_FULFILLED'});
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Pseudo logout failed"/>);
      const data = {
        ...error.response.data.errors
      };
      return Promise.reject(data)
    })
};

export const resetPrivacyPolicyForAllUsers = () => (dispatch) => {
  return irelandApi.patch('api/admin/users/reset_privacy_policy')
    .then((response) => {
      toast.success(<ToastMessage iconStyle="success" message="All user's privacy policy consent has been reset."/>);
    })
    .catch((error) => {
      toast.error(<ToastMessage iconStyle="error" message="Failed to reset privacy policy consents."/>);
      return Promise.reject();
    })
};




// WEBPACK FOOTER //
// ./src/actions/users.js